export default __webpack_public_path__ + "static/media/arrows.ffd0d7f0.png";